import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { checkCardStatus } from '../store/api/GuaranteeApi';
import { useHistory } from 'react-router-dom'
import Loader from 'react-loader-spinner';
import QRCodeReader from "../Components/QRCode_Reader/QR_Reader";
import { setQrPopupStatus } from "../store/api/GetAllProduct";
import barCodeImg from "../content/images/barcodeReader.png";
import { CheckSquare } from 'react-bootstrap-icons';

const GuaranteeCardStatus = () => {
    useEffect(() => {
        document.body.classList = "notMain";
    }, []);
    const qrCodePop = useSelector(state => state.popup?.qrCodePop);
    const isLoading = useSelector(state => state.loading?.isLoading)
    const dispatch = useDispatch();
    const { register, handleSubmit } = useForm();
    const onScanQrCode = (type, value) => {
        document.getElementsByName(type)[0].value = value;
    }
    const history = useHistory();
    const onSubmit = (data) => {
        dispatch(
            checkCardStatus(data, () => {
                history.push("/Services/GuaranteeStatusResult")
            })
        );
    }

    return (
        <div className="container-fluid mt-2">
            <br />
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="card">
                    <div className="card-header headerStyle" style={{ textAlign: "center" }}>استعلام گارانتی</div>
                    <div className="card-body bodyStyle">
                        <div className='row'>
                            <div className='col-md-2' style={{ margin: "auto" }}>
                                {qrCodePop.show === true && <QRCodeReader />}
                            </div>
                        </div>
                        <div className='row'>
                            <div className="form-group col-md-3">
                                <label>شماره سریال</label>
                                <input type="text" name="SerialNumber" className="form-control" style={{ display: "inline-block", width: "94%", fontFamily: "Dark-Sans", fontSize: "11.5px" }} ref={register} />
                                {window.innerWidth <= 414 && <button className="btn btn-default btn-block" type="button" onClick={() => { dispatch(setQrPopupStatus({ show: true, onScan: (value) => onScanQrCode("SerialNumber", value) })); }}
                                    style={{ padding: 0, display: "inline-block", position: "absolute", marginTop: "9px", marginRight: "2px" }}><img src={barCodeImg} alt="" style={{ height: "27px" }} /></button>}
                            </div>
                            <div className="form-group col-md-3">
                                <label>شماره گارانتی</label>
                                <input type="text" name="CardNo" className="form-control" style={{ display: "inline-block", width: "94%", fontFamily: "Dark-Sans", fontSize: "11.5px" }} ref={register} />
                                {window.innerWidth <= 414 && <button className="btn btn-default btn-block" type="button" onClick={() => { dispatch(setQrPopupStatus({ show: true, onScan: (value) => onScanQrCode("CardNo", value) })); }}
                                    style={{ padding: 0, display: "inline-block", position: "absolute", marginTop: "9px", marginRight: "2px" }}><img src={barCodeImg} alt="" style={{ height: "27px" }} /></button>}
                            </div>
                        </div>
                        <button className="btn btn-primary btn-block group-Btn mt-2">{!isLoading && 'استعلام کارت'}{isLoading && <Loader type="BallTriangle" color="#bb1370" height={20} width={20} />}</button>
                    </div>
                </div>
            </form>
        </div>

    );
}
export default GuaranteeCardStatus;